export default __webpack_public_path__ + "static/mini-2-9c84a7c94601bc6be29b2ad143fb2fd2.png";